module.exports = __webpack_public_path__ + "img/gonetwork2_icon15.4ef14f71.png";